import * as React from 'react';
import {Trans, useTranslation} from '@deviceinsight/ng-ui-scale-lib/api';
import {Button} from '@deviceinsight/ng-ui-basic-components';
import iconMagnifier from '../../assets/icon_lupe.png';
import {SearchConfig} from './types';
import SearchInput from './SearchInput';
import {parse} from './queryParser';
import {TranslationDescriptor} from '@deviceinsight/ng-ui-scale-lib/api';
export type OwnProps = {
	context: string;
	config?: SearchConfig<any>;
	onChange?: (query: string) => void;
	onSubmit?: (query: string) => void;
	autofocus?: boolean;
	placeholder?: TranslationDescriptor;
	initialValue?: string | null | undefined;
	children?: React.ReactNode;
};
const Search: React.FC<OwnProps> = ({config, autofocus, placeholder, children, initialValue, onChange, onSubmit}) => {
	const {t} = useTranslation();
	const [state, setState] = React.useState({
		query: initialValue || '',
		queryTokens: parse(initialValue || ''),
		invalidQueryInput: false,
		submitted: true
	});

	const handleChangeQuery = React.useCallback(
		(query: string) => {
			const queryTokens = parse(query);
			setState({
				query,
				queryTokens,
				invalidQueryInput: query.length > 0 && queryTokens === null,
				submitted: false
			});

			if (onChange) {
				onChange(query);
			}
		},
		[onChange]
	);

	const handleSubmitQuery = React.useCallback(
		(query: string) => {
			if (!state.invalidQueryInput) {
				const queryTokens = parse(query);
				setState({
					query,
					queryTokens,
					invalidQueryInput: false,
					submitted: true
				});

				if (onSubmit) {
					onSubmit(query);
				}
			}
		},
		[onSubmit, state.invalidQueryInput]
	);

	const {query, queryTokens, invalidQueryInput, submitted} = state;
	return (
		<span className="di search-bar rafi">
			{children}
			<SearchInput
				config={config}
				query={query}
				queryTokens={queryTokens}
				submitted={submitted}
				onChange={handleChangeQuery}
				onSubmit={handleSubmitQuery}
				autofocus={autofocus || false}
				placeholder={placeholder}
			/>
			<span
				className="search-submit-btn"
				title={t('search.submit', {
					defaultValue: 'Submit Search'
				})}>
				<Button onClick={() => handleSubmitQuery(query)}>
					<img src={iconMagnifier} alt="search icon" />
				</Button>
			</span>

			{invalidQueryInput && (
				<span className="di search-info">
					<Trans i18nKey="search.searchBarInvalidQuery">Please complete your query ...</Trans>
				</span>
			)}
		</span>
	);
};

export default Search;
